<template>
  <transition name="el-fade-in-linear">
    <div class="topologymap-controlbar topology-icon-group" v-show="(isHover || isVisible)" @mouseover="isHover = true" @mouseout="isHover = false">
      <!-- 도움말 및 범례 -->
      <!-- <el-tooltip content="도움말 및 범례" placement="top">
        <div class="help-control">
          <el-button :class="['map-help-icon', helpPopupStatus ? 'selected' : '']" @click="onClickHelpBtn"></el-button>
        </div>
      </el-tooltip> -->
      <!-- <div class="btn-list btn-with-label">
        <el-button size="medium" type="content" :class="['btn-full', (isFullScreen ? 'tl-3' : 'tl-4')]" @click="onFullscreenBtnClick">
          {{ isFullScreen ? '나가기' : '전체화면' }}
        </el-button>
        <div class="btn-multi" v-if="true">
          <el-button size="medium" type="content" class="tl-3" @click="onLayoutBtnClick(MapConst.LAYOUT_TYPE.RADIAL)">
            방사형
          </el-button>
          <el-button size="medium" type="content" class="tl-3" @click="onLayoutBtnClick(MapConst.LAYOUT_TYPE.TREE)">
            트리형
          </el-button>
          <el-button size="medium" type="content" class="tl-2" @click="onLayoutBtnClick(MapConst.LAYOUT_TYPE.CUSTOM)">
            수동
          </el-button>
        </div>
        <div class="btn-multi">
          <el-button size="medium" type="content" class="btn-auto tl-4" @click="onZoomFitBtnClick">
            화면맞춤
          </el-button>
          <el-button size="medium" type="content" class="btn-fit tl-4" @click="onZoomResetBtnClick">
            원래크기
          </el-button>
        </div>
        <el-button size="medium" type="content" class="btn-screenshot tl-4" @click="onDownloadBtnClick">
          화면캡처
        </el-button>
        <el-button size="medium" type="content" class="btn-pin tl-4" @click="onPinStatusClick">
          화면고정
        </el-button>
        <el-button size="medium" type="content" class="btn-minimap tl-3" @click="onMinimapBtnClick">
          미니맵
        </el-button>
      </div> -->
      <div class="btn-list">
        <el-tooltip :content="pinStatus ? '화면고정 해제' : '화면고정'" placement="left" v-if="!isEditMode">
          <el-button size="medium" type="content" :class="[(pinStatus ? 'btn-pin' : 'btn-pin-off')]" @click="onPinStatusClick"></el-button>
        </el-tooltip>
        <el-tooltip content="확대" placement="left">
          <el-button size="medium" type="content" @click="onZoomoutClick('zoom')">
            <i class="far fa-plus"></i>
          </el-button>
        </el-tooltip>
        <el-tooltip content="축소" placement="left">
          <el-button size="medium" type="content" @click="onZoomoutClick('out')">
            <i class="far fa-minus"></i>
          </el-button>
        </el-tooltip>
      </div>
    </div>
  </transition>
</template>

<script>
import MapAPI from '@/api/topologymap/common';
import Base from '@/mixins/topologymap/base';
import MapConst from '@/constants/topologymap';
import { MapInfo, MapPopup } from '@/views/topologymap/js/maps';
import WCategoryWindow from '@/views/topologymap/components/monitoring/CategoryWindow';
import WMinimapWindow from '@/views/topologymap/components/monitoring/MinimapWindow';

export default {
  name: 'WMapControlbar',
  mixins: [Base],
  components: {
  },
  data() {
    return {
      MapConst,
      pinStatus: false,
      isHover: false,
      isVisible: false,
      helpPopupStatus: false,
    };
  },
  created() {
    MapInfo.getInstance(this).addMapCompleteCallback(this.init);
  },
  mounted() {
    const layout = document.querySelector('.graph-area');
    if (layout) {
      layout.addEventListener('mousemove', this.onMouseMove);
    }
  },
  beforeDestroy() {
    const layout = document.querySelector('.graph-area');
    if (layout) {
      layout.removeEventListener('mousemove', this.onMouseMove);
    }
  },
  methods: {
    // 무슨영문인지 this.graph에 데이터를 바인딩하면 graph랜더링 속도가 느려진다.
    // 그래서 graph가 필요한 곳에서는 MapInfo.getInstance(this).getGraph(); 를 사용하도록 바꿨다.
    init() {
      this.setPinStatus();
    },
    setPinStatus() {
      this.pinStatus = MapInfo.getInstance(this).isViewPin();
    },
    onPinStatusClick() {
      const graph = MapInfo.getInstance(this).getGraph();
      const topologymapModel = graph.topologymapModel;
      if (this.pinStatus) {
        topologymapModel.x = null;
        topologymapModel.y = null;
        topologymapModel.mapScale = null;
      } else {
        topologymapModel.x = graph.tx;
        topologymapModel.y = graph.ty;
        topologymapModel.mapScale = graph.scale;
      }

      MapAPI.updateTopologymapViewStatus(topologymapModel.mapId, topologymapModel.x, topologymapModel.y, topologymapModel.mapScale).then(() => {
        if (this.pinStatus) {
          this.$message.success('화면 고정이 해제되었습니다.');
        } else {
          this.$message.success('화면 고정이 설정되었습니다.');
        }
        this.pinStatus = !this.pinStatus;
      });
    },
    onZoomoutClick(type) {
      const graph = MapInfo.getInstance(this).getGraph();
      if (type === 'zoom') {
        graph.zoomIn();
      } else {
        graph.zoomOut();
      }
    },
    showControl() {
      if (window.controlVisibleTimeout) {
        clearTimeout(window.controlVisibleTimeout);
      }
      this.isVisible = true;
      window.controlVisibleTimeout = setTimeout(() => {
        this.isVisible = false;
      }, 5000);
    },
    onMouseMove() {
      this.showControl();
    },
    onClickHelpBtn() {
      if (this.helpPopupStatus) {
        this.helpPopupStatus = false;
        // 팝업을 삭제하는 이유는 처음 팝업이 열렸던 위치에서 항상 열리게 하기 위함이다.
        MapPopup.closeAndHide(WCategoryWindow.name, true);
      } else {
        this.helpPopupStatus = true;
        MapPopup.showPopup(WCategoryWindow, {
          events: {
            closed: () => {
              this.helpPopupStatus = false;
            },
            hidden: () => {
              this.helpPopupStatus = false;
              MapPopup.closeAndHide(WCategoryWindow.name, true);
            },
          },
        });
      }
    },
    onFullscreenBtnClick() {
      if (this.isFullScreen) {
        MapInfo.getInstance(this).getCanvas().exitFullScreen();
      } else {
        MapInfo.getInstance(this).getCanvas().fullScreen();
      }
    },
    onZoomFitBtnClick() {
      MapInfo.getInstance(this).getCanvas().zoomFit();
    },
    onZoomResetBtnClick() {
      MapInfo.getInstance(this).getCanvas().zoomReset();
    },
    onDownloadBtnClick() {
      this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.MAP_DOWNLOAD, {
        model: MapInfo.getInstance(this).getGraph().topologymapModel,
      });
    },
    onMinimapBtnClick() {
      const popup = MapPopup.getPopup(WMinimapWindow.name);

      if (popup && popup.wrapper && popup.wrapper.$el.style.visibility === 'visible') {
        MapPopup.closeAndHide(WMinimapWindow.name);
      } else {
        MapPopup.showPopup(WMinimapWindow);
      }
    },
    onLayoutBtnClick(type) {
      MapInfo.getInstance(this).getCanvas().doAutoLayout(type, true);
    },
  },
};
</script>

<style lang="scss">
@mixin disable() {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.5);
  width: 100%;
  height: 100%;
  z-index: 9999;
  cursor: not-allowed;
}

.topologymap-controlbar {
  position: absolute;
  top: 10px;
  right: 15px;
  z-index: 1;
  width: 40px;

  .btn-list {
    display: flex;
    flex-direction: column;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 1px 2px 0px;
    border-radius: 4px;

    button {
      border-radius: 0;
      margin-top: -1px;

      &:first-child {
        border-radius: 4px 4px 0 0;
      }
      &:last-child {
        border-radius: 0 0 4px 4px;
      }

      .fa, .fas, .far, .fal, .fad, .fab {
        vertical-align: middle;
      }

      &:hover,
      &.selected {
        z-index: 1;
        color: #5077CF;
      }
    }

    .btn-multi {
      display: flex;
      flex-direction: row-reverse;

      button {
        &:not(:first-child) {
          display: none;
        }
        &:first-child {
          border-radius: 0;
        }
        &:last-child {
          border-radius: 4px 0 0 4px;
        }
      }

      &:hover {
        button {
          display: block;
        }
      }
    }
  }

  .btn-with-label {
    button {
      width: 42px;
      height: 43px;
      position: relative;
      background-position-y: 7px !important;

      span {
        position: absolute;
        left: 0;
        bottom: 3px;
        font-size: 10px;
      }

      &.tl-4 > span {
        left: 2px;
      }
      &.tl-3 > span {
        left: 6px;
      }
      &.tl-2 > span {
        left: 11px;
      }
    }
  }

  .fullscreen-control {
    cursor: pointer;
    width: 35px;
    height: 35px;
    text-align: center;
    vertical-align: middle;
    line-height: 35px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 3px;
    margin-bottom: 50px;
    color: #fff;

    &:hover {
      background: #000;
    }

    &:before, &:after {
      position: absolute;
      left: 17px;
      content: ' ';
      height: 25px;
      width: 1px;
      background-color: #fff;
      top: 5px;
    }
    &:before {
      transform: rotate(45deg);
    }
    &:after {
      transform: rotate(-45deg);
    }
  }

  .help-control {
    cursor: pointer;
    width: 35px;
    height: 35px;
    text-align: center;
    vertical-align: middle;
    line-height: 35px;
    background: #fff;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 1px 2px 0px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 3px;
    margin-bottom: 10px;
    button {
      width: 100%;
      height: 100%;
      background-position: center;
      border: none;
    }
  }
  .pin-control {
    cursor: pointer;
    width: 35px;
    height: 35px;
    text-align: center;
    vertical-align: middle;
    line-height: 35px;
    background: #fff;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 1px 2px 0px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 3px;
    margin-bottom: 10px;

    &.enabled {
      background-color: #38608E;
      color: #fff;
    }
  }

  .zoomout-control {
    position: relative;
    float: left;
    width: 36px;
    border-radius: 3px;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 1px 2px 0px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    background: #fff;

    .zoomout-btn {
      float: left;
      cursor: pointer;
      width: 35px;
      height: 35px;
      text-align: center;
      vertical-align: middle;
      line-height: 35px;

      &.zoom {
        border-bottom: 1px solid rgb(226, 226, 226);
        border-radius: 3px 3px 0px 0px;
      }
      &.out {
        border-top: 1px solid rgb(226, 226, 226);
        border-radius: 0px 0px 3px 3px;
      }
    }

    &.disable::after {
      @include disable();
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/MapControlbar.vue